import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

import { getCitiesWithMajorByPrefecture } from 'Packs/src/subsidies/api/getCitiesWithMajorByPrefecture'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-sideSearchWidget-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

// デフォルトの工事箇所（外壁塗装）
const DEFAULT_PART_SLUG = 'exterior_outer-wall'

/**
 * 検索条件に基づいて静的エリアページURLを構築する
 * @param {string|null} prefectureId - 都道府県ID
 * @param {string|null} cityId - 市区町村ID
 * @param {string[]} partTypes - 選択された工事箇所のURL slug配列
 * @returns {string} 遷移先URL
 */
const buildAreaPageUrl = (prefectureId, cityId, partTypes) => {
  // P4: 都道府県なし（パラメータ不正）の場合は補助金TOPへ
  if (!prefectureId) {
    return '/subsidies'
  }

  // 工事箇所が選択されていない場合は外壁塗装をデフォルトとする
  const partSlug = partTypes.length > 0 ? partTypes[0] : DEFAULT_PART_SLUG

  // P1: 都道府県 + 市区町村 + 工事箇所が1つ以上
  if (cityId) {
    return `/subsidies/area/${prefectureId}/${cityId}/part/${partSlug}?search=1`
  }

  // P2, P3: 都道府県 + 工事箇所（市区町村なし）
  return `/subsidies/area/${prefectureId}/part/${partSlug}?search=1`
}

/**
 * フォーム送信をインターセプトして静的エリアページへ直接遷移させる
 */
const handleFormSubmit = () => {
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $form = $(root)

    $form.on('submit', (event) => {
      event.preventDefault()

      // 都道府県の値を取得
      const $prefectureSelect = $form.find('#prefecture')
      const prefectureId = $prefectureSelect.val()

      // 市区町村の値を取得
      const $citySelect = $form.find('#city')
      const cityId = $citySelect.val()

      // 工事箇所の値を取得
      const $partTypeCheckboxes = $form.find('input[name="part_types[]"]:checked')
      const partTypes = $.map($partTypeCheckboxes, (checkbox) => $(checkbox).val())

      // 都道府県が選択されていない場合は補助金TOPへ遷移
      if (!prefectureId) {
        window.location.href = '/subsidies'
        return
      }

      // URLを構築して遷移
      const url = buildAreaPageUrl(prefectureId, cityId, partTypes)
      window.location.href = url
    })
  })
}

const activateSubmit = () => {
  // セレクタ定義
  const AREA_INPUT_ROOT_TARGET_CLASS_NAME = 'js-sideSearchWidget-activateSubmit-areaInput-root-target'
  const AREA_INPUT_ROOT_TARGET_SELECTOR = `.${AREA_INPUT_ROOT_TARGET_CLASS_NAME}`

  const AREA_INPUT_TARGET_CLASS_NAME = 'js-sideSearchWidget-activateSubmit-areaInput-target'
  const AREA_INPUT_TARGET_SELECTOR = `.${AREA_INPUT_TARGET_CLASS_NAME}`

  const CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_CLASS_NAME = 'js-sideSearchWidget-activateSubmit-constructionPartsInput-root-target'
  const CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_SELECTOR = `.${CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_CLASS_NAME}`

  const CONSTRUCTION_PARTS_INPUT_TARGET_CLASS_NAME = 'js-sideSearchWidget-activateSubmit-constructionPartsInput-target'
  const CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR = `.${CONSTRUCTION_PARTS_INPUT_TARGET_CLASS_NAME}`

  const BUTTON_TARGET_CLASS_NAME = 'js-sideSearchWidget-activateSubmit-button-target'
  const BUTTON_TARGET_SELECTOR = `.${BUTTON_TARGET_CLASS_NAME}`

  // アクティブ状態のクラス定義
  const ACTIVE_CLASS_NAME = 'is-active'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $submitButton = $(root).find(BUTTON_TARGET_SELECTOR)
    const $areaInputRoot = $(root).find(AREA_INPUT_ROOT_TARGET_SELECTOR)
    const $constructionPartsInputRoot = $(root).find(CONSTRUCTION_PARTS_INPUT_ROOT_TARGET_SELECTOR)

    // ボタン活性化判定処理
    const determinationOfActivation = () => {
      const areaValueArray = $.map($areaInputRoot, (areaInputRoot) => {
        const $areaInput = $(areaInputRoot).find(AREA_INPUT_TARGET_SELECTOR)
        return $.map($areaInput, (areaInput) => {
          return $(areaInput).val()
        })
      }).filter((value) => value)

      const constructionPartsValueArray = $.map($constructionPartsInputRoot, (constructionPartsInputRoot) => {
        const $constructionPartsInput = $(constructionPartsInputRoot).find(`${CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR}:checked`)
        return $.map($constructionPartsInput, (constructionPartsInput) => {
          return $(constructionPartsInput).val()
        })
      }).filter((value) => value)

      if (areaValueArray.length > 0 || constructionPartsValueArray.length > 0) {
        $submitButton.addClass(ACTIVE_CLASS_NAME)
      } else {
        $submitButton.removeClass(ACTIVE_CLASS_NAME)
      }
    }

    // イベント登録
    $areaInputRoot.each((index, areaInputRoot) => {
      const $areaInput = $(areaInputRoot).find(AREA_INPUT_TARGET_SELECTOR)

      $areaInput.on('change', determinationOfActivation)
    })

    $constructionPartsInputRoot.each((index, constructionPartsInputRoot) => {
      const $constructionPartsInput = $(constructionPartsInputRoot).find(CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR)

      $constructionPartsInput.on('change', determinationOfActivation)
    })

    // 初期値判定
    determinationOfActivation()
  })
}

const updateCity = () => {
  // セレクタ定義
  const TRIGGER_CLASS_NAME = 'js-sideSearchWidget-updateCity-trigger'
  const TRIGGER_SELECTOR = `.${TRIGGER_CLASS_NAME}`

  const TARGET_CLASS_NAME = 'js-sideSearchWidget-updateCity-target'
  const TARGET_SELECTOR = `.${TARGET_CLASS_NAME}`

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $updateCityTrigger = $(root).find(TRIGGER_SELECTOR)
    const $updateCityTarget = $(root).find(TARGET_SELECTOR)

    $updateCityTrigger.on('change', (event) => {
      const $currentTrigger = $(event.currentTarget)
      const prefectureName = $currentTrigger.find('option:selected').text()

      // 市区町村のセレクトボックスをリセット
      $updateCityTarget.parent().removeClass('is-done') // 完了状態のリセット
      $updateCityTarget.addClass('is-untouched') // ブランク状態に戻す
      $updateCityTarget.val('') // valueをリセット
      $updateCityTarget.html('') // optionタグをリセット
      $updateCityTarget.append('<option value="">市区町村を選択</option>')

      // 市区町村の更新
      $updateCityTarget.prop('disabled', true) // 更新が終わるまで非活性化
      getCitiesWithMajorByPrefecture(prefectureName, (cities) => {
        const kanaGroupData = []

        // ヨミガナの配列を作成、重複を削除して返却値の配列に値を格納
        const kanaList = []
        cities.forEach((city) => {
          kanaList.push(city.yomi.slice(0, 1))
        })
        kanaList
          .filter((x, i) => kanaList.indexOf(x) === i)
          .forEach((kana) => {
            kanaGroupData.push({ kana, cities: [] })
          })

        // ヨミガナの配列から先頭文字を判定し新たな配列を作成
        kanaGroupData.forEach((item) => {
          cities.forEach((city) => {
            if (item.kana === city.yomi.slice(0, 1)) {
              item.cities.push(city)
            }
          })
        })

        const optgroups = $.map(kanaGroupData, (data) => {
          return `<optgroup label="${data.kana}">${$.map(data.cities, (city) => `<option value="${city.id}">${city.name}</option>`).join('')}</optgroup>`
        }).join('')

        $updateCityTarget.append(optgroups)

        if (gon.city_id_for_side_search_widget) {
          const $selectedCity = $updateCityTarget.find(`option[value="${gon.city_id_for_side_search_widget}"]`)
          // 市区町村がない場合は処理を終了
          if ($selectedCity.length === 0) {
            $updateCityTarget.prop('disabled', false) // 処理が終わったら活性化
            return
          }

          $selectedCity.prop('selected', true)
          $updateCityTarget.parent().addClass('is-done') // 完了状態の追加
          $updateCityTarget.removeClass('is-untouched') // ブランク状態の解除

          // gonの値をリセット
          gon.city_id_for_side_search_widget = null
        }

        $updateCityTarget.prop('disabled', false) // 処理が終わったら活性化
      })
    })
  })
}

// 市区町村の初期値設定
const setCities = () => {
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  const TRIGGER_CLASS_NAME = 'js-sideSearchWidget-updateCity-trigger'
  const TRIGGER_SELECTOR = `.${TRIGGER_CLASS_NAME}`

  $rootElement.find(TRIGGER_SELECTOR).trigger('change')
}

$(() => {
  // submitボタンの活性化処理
  activateSubmit()

  // 市区町村の更新処理
  updateCity()

  // 都道府県がある場合、市区町村の初期値を設定
  if (gon.prefecture_id) {
    setCities()
  }

  // フォーム送信処理（静的エリアページへ直接遷移）
  handleFormSubmit()
})
